import { popupsApi } from "./popups.api";

export const {
  useGetPopupsByCompanyQuery,
  useGetPopupByCompanyQuery,
  useSavePopupMutation,
  useDeletePopupMutation,
  useUploadPopupImageMutation,
  useGetPopupsUsersCountQuery,
  useGetPopupsViewsCountQuery
} = popupsApi;
